import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthLayoutComponent } from './auth.layout';
import { RouterModule } from '@angular/router';
import { FooterModule } from '../../components/footer/footer.module';
import { P500UIButtonsModule, P500UINotificationsModule } from '@platform500services/p500-ui-kit';
import { AnalyticsComponent } from '../../components/analytics/analytics.component';

@NgModule({
  declarations: [AuthLayoutComponent],
  exports: [AuthLayoutComponent],
  imports: [CommonModule, RouterModule, FooterModule, P500UINotificationsModule, AnalyticsComponent, P500UIButtonsModule],
})
export class AuthLayoutComponentModule {}
